export default __webpack_public_path__ + "static/media/nft-16.1ade6d9b.png";